module.exports = __webpack_public_path__ + "img/mainBg.87853e3b.png";